import { Component, OnInit } from '@angular/core';
import { domain } from '../../common/text';

declare const GAMING: boolean;

@Component({
  selector: 'pfm-footer',
  styleUrls: ['./pfm-footer.component.scss'],
  templateUrl: './pfm-footer.component.pug'
})
export class PfmFooter implements OnInit {
  public today: Date;
  public url: string = domain[GAMING ? 'gaming' : 'pfm']
  public contactLink: string = GAMING ? 'mailto:inquiries@patchnotesgaming.com' : 'https://pfm-help.freshdesk.com/support/home'

  public ngOnInit() {
    this.today = new Date();
  }

}
